<div class="banner">
  <ng-content select="ez-stepper"></ng-content>
  <div class="banner-text banner-text-primary" aria-level="1" role="heading">
    <ng-content select="title"></ng-content>
  </div>
  <div class="banner-text banner-text-secondary">
    <ng-content select="subtitle"></ng-content>
  </div>
</div>
